import { Select, MenuItem, FormControl, styled } from "@mui/material";
import type { DocumentType } from "@interfaces";
import { DocumentTypeLabels } from "@interfaces";

const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: theme.palette.text.secondary,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
    },
  },
  "& .MuiSelect-icon": {
    color: theme.palette.icon.primary,
    "&.Mui-disabled": {
      display: "none",
    },
  },
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: "Poppins",
  fontSize: "16px",
  "&:hover": {
    backgroundColor: theme.palette.background.disabled,
  },
  "&.Mui-selected": {
    backgroundColor: theme.palette.success.light,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
}));

const InputLabel = styled("label")<{ disabled?: boolean }>(({ disabled, theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "23px",
  paddingBottom: "4px",
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
}));

interface DocumentTypeSelectionProps {
  value: DocumentType;
  onChange: (documentType: DocumentType) => void;
  disabled?: boolean;
  label?: string;
  fullWidth?: boolean;
}

export function DocumentTypeSelection({
  value,
  onChange,
  disabled = false,
  label = "Tipo de documento",
  fullWidth = true,
}: DocumentTypeSelectionProps) {
  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel disabled={disabled}>{label}</InputLabel>
      <StyledSelect
        value={value}
        onChange={(e) => onChange(e.target.value as DocumentType)}
        disabled={disabled}
      >
        {Object.entries(DocumentTypeLabels).map(([key, label]) => (
          <StyledMenuItem key={key} value={key}>
            {label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
}
